import React from "react";
import { FormikProps } from "formik";

import {
  Row,
  Col,
  GKFormGroup,
  GKLabel,
  GKInput,
  GKForm,
  GKSelect,
  GKOption,
  GKButton,
  GKFormFeedback,
  GKLoading,
  GKLoadingType,
} from "@granular/gds-ux-components";

import { CreatorRole } from "../../";

import FormattedMessage from "./FormattedMessage";

const Form: React.FC<
  FormikProps<{
    newOperationName: string;
    creatorRole: CreatorRole;
  }> & {
    showRoleDropdown: boolean;
  }
> = ({
  dirty,
  errors,
  handleChange,
  isSubmitting,
  isValid,
  setFieldValue,
  submitForm,
  values,
  showRoleDropdown,
}) => (
  <GKForm
    id="create-form"
    data-testid="create-form"
    action="none"
    onSubmit={(e) => e.preventDefault()}
  >
    <Row>
      <Col>
        <h2
          className="mb-4"
          id="create-operation-title"
          data-testid="create-operation-title"
        >
          <FormattedMessage id="Welcome_to_Granular_Insights_" />
        </h2>
      </Col>
    </Row>

    <Row>
      <Col
        md={{
          size: 6,
        }}
      >
        <p
          id="create-operation-description"
          data-testid="create-operation-description"
          className="mt-md-4"
        >
          <FormattedMessage id="First_give_your_operation_a_name__then_you" />
        </p>
      </Col>
      <Col>
        <GKFormGroup>
          <GKLabel className="required" for="newOperationName">
            <FormattedMessage id="Operation_Name" />
          </GKLabel>
          <GKInput
            id="create-operation-name"
            data-testid="create-operation-name"
            name="newOperationName"
            onChange={handleChange}
            type="text"
            disabled={isSubmitting}
            value={values.newOperationName}
          />
          <GKFormFeedback>
            <GKFormFeedback>{errors.newOperationName}</GKFormFeedback>
          </GKFormFeedback>
        </GKFormGroup>
      </Col>
    </Row>

    {showRoleDropdown && (
      <>
        <hr />
        <Row id="advisor-row" data-testid="advisor-row">
          <Col
            md={{
              size: 6,
            }}
          >
            <p className="mt-md-4">
              <FormattedMessage id="as_an_advisor_you_have" />
            </p>
            <p>
              <FormattedMessage id="farmer_please_change_role" />
            </p>
          </Col>
          <Col>
            <GKFormGroup id="advisor-drop-down" data-testid="advisor-drop-down">
              <GKLabel className="required" for="creatorRole">
                <FormattedMessage id="Role" />
              </GKLabel>
              <GKSelect
                name="creatorRole"
                disabled={isSubmitting}
                selectedItem={values.creatorRole}
                onChange={(value) => setFieldValue("creatorRole", value)}
              >
                <GKOption key={"administrator"} value={"administrator"}>
                  <FormattedMessage id={"Admin"} />
                </GKOption>
                <GKOption key={"advisor"} value={"advisor"}>
                  <FormattedMessage id={"Advisor"} />
                </GKOption>
              </GKSelect>
            </GKFormGroup>
          </Col>
        </Row>
      </>
    )}

    <hr />

    <Row>
      <Col
        md={{
          size: 6,
          offset: 6,
        }}
      >
        <GKButton
          color="primary"
          className="w-100"
          data-testid="create-operation-save"
          disabled={!isValid || isSubmitting || !dirty}
          type="submit"
          onClick={submitForm}
        >
          {isSubmitting ? (
            <GKLoading
              isLoading={true}
              type={GKLoadingType.Spinner}
              inline={true}
              id="create-operation-spinner"
              data-testid="create-operation-spinner"
              spinnerProps={{ width: 16, inverse: true }}
            />
          ) : (
            <span>
              <FormattedMessage id="common_save" />
            </span>
          )}
        </GKButton>
      </Col>
    </Row>
  </GKForm>
);

export default Form;
